<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card class="Reports">
            <b-form class="formBox"> 
                <b-form-group class="radioGroup" label="Rapor Tipi" label-for="type">
                    <b-form-radio-group
                        id="type"
                        v-model="type"
                        :options="types"
                        aria-describedby="live-feedback"></b-form-radio-group>
                </b-form-group>
                <b-form-group class="radioGroup" label="Abone Tipi" label-for="accountType">
                    <b-form-radio-group
                        id="accountType"
                        v-model="accountType"
                        :options="accountTypes"
                        aria-describedby="live-feedback"></b-form-radio-group>
                </b-form-group>

                <b-form-group v-if="type == 1" class="inputGrp" label="Abone Aralığı" label-for="accountNoStrt">
                    <b-form-input
                        id="accountNoStrt"
                    ></b-form-input>
                    <b-form-input
                        id="accountNoEnd"
                        aria-describedby="live-feedback"
                    ></b-form-input>
                </b-form-group>

                <b-form-group v-if="type == 2" class="inputGrp" label="Seçili Aboneler" label-for="Accounts">
                    <b-form-tags input-id="tags-basic" v-model="accounts" placeholder="Abone Kodları"></b-form-tags>
                </b-form-group>

                <div class="options">
                        <b-form-group class="inputGrp" label="" label-for="AlarmCenter">
                    <div class="elements">
                        <b-form-checkbox  v-model="allAlarmCenter" >Tüm Merkezler</b-form-checkbox> 
                        <Multiselect v-model="alarmCenter" :show-labels="false" :options="alarmCenters" :multiple="true" v-if="!allAlarmCenter" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                       
                    </div>
                </b-form-group>    
                <b-form-group class="inputGrp" label="" label-for="Dealer">
                    <div class="elements">
                        <b-form-checkbox  v-model="allDealer"> Tüm Teknik Servisler</b-form-checkbox> 
                         <Multiselect  v-model="dealer" :options="dealers" :multiple="true" v-if="!allDealer" :show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>  
                <b-form-group class="inputGrp" label="" label-for="City">
                    <div class="elements">
                        <b-form-checkbox  v-model="allCity"> Tüm İller </b-form-checkbox> 
                        <Multiselect  v-model="city" :options="cities" :multiple="true" v-if="!allCity" :show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group> 
                 <b-form-group class="inputGrp" label="" label-for="District">
                    <div class="elements">
                        <b-form-checkbox  v-model="alldistrict" > Tüm İlçeler </b-form-checkbox> 
                        <Multiselect v-model="district" :options="districts" :multiple="true" v-if="!alldistrict" :show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
                 <b-form-group class="inputGrp" label="" label-for="Job">
                    <div class="elements">
                        <b-form-checkbox  v-model="allJob" > Tüm Meslekler</b-form-checkbox> 
                        <Multiselect  v-model="job" :options="jobs" :multiple="true" v-if="!allJob" :show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
                 <b-form-group class="inputGrp" label="" label-for="District">
                    <div class="elements">
                        <b-form-checkbox  v-model="allProtocols" > Tüm Protokoller</b-form-checkbox> 
                        <Multiselect  v-model="protocol" :options="protocols" :multiple="true" v-if="!allProtocols" :show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
                 <b-form-group class="inputGrp" label="" label-for="District">
                    <div class="elements">
                        <b-form-checkbox  v-model="allDevice" > Tüm Paneller</b-form-checkbox> 
                        <Multiselect  v-model="device" :options="devices" :multiple="true" v-if="!allDevice" show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
                  <b-form-group class="inputGrp" label="" label-for="District">
                    <div class="elements">
                        <b-form-checkbox  v-model="allCommunicate" > Tüm Haberleşme Türleri</b-form-checkbox> 
                        <Multiselect v-model="communicate" :options="communicates" :multiple="true" v-if="!allCommunicate" show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                        <Multiselect v-model="communicate" :options="communicates" :multiple="true" v-if="!allCommunicate" ></Multiselect>
                    </div>
                </b-form-group>
                  <b-form-group class="inputGrp" label="" label-for="District">
                    <div class="elements">
                        <b-form-checkbox  v-model="allCG" > Tüm Zincir Aboneler</b-form-checkbox> 
                        <Multiselect  v-model="customerGroup" :options="customerGroups" :multiple="true" v-if="!allCG" show-labels="false" label="text" track-by="text" >
                            <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.text }}</strong> 
                            </template>
                        </Multiselect>
                    </div>
                </b-form-group>   
                </div>
                   
            </b-form>
            <template v-slot:footer class="footer">
                <b-button variant="danger" @click="openModal(true, 'pdf',jsondata )">PDF'e Aktar</b-button>
            </template>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Modals from './modals/'
    import Multiselect from 'vue-multiselect'
    import { saveAs } from 'file-saver';

    let breadCrumb = [
        { label: "Raporlar", url: "/Reports" },
        { label: "Emniyet Raporu", url: "/Reports/Safety" },
    ]

    export default {
        name: 'Reports',
        data:function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Reports",
                modalName: "",
                type: 0,
                dealer: null,
                accountType: 0,
                alarmCenter: null,
                allAlarmCenter: true,
                allDealer: true,
                allCity: true,
                alldistrict: true,
                allJob: true,
                allProtocols: true,
                allDevice: true,
                allCommunicate: true,
                allCG: true,
                accounts: [],
                types: [
                    { text: 'Tüm Aboneler', value: 0 },
                    { text: 'Abone Aralığı', value: 1 },
                    { text: 'Seçili Aboneler', value: 2 },
                ],
                accountTypes: [
                    { text: 'Aktif Aboneler', value: 0 },
                    { text: 'Pasif Aboneler', value: 1 },
                    { text: 'İptal Aboneler', value: 2 },
                ],
                alarmCenters: [
                    { text: 'Prosec Alarm Merkezi', value: 0 },
                    { text: 'Alertis Alarm Merkezi', value: 1 },
                    { text: 'Sanat Alarm Merkezi', value: 2 },
                ],
                dealers: [
                    { text: 'Prosec Güvenlik', value: 0 },
                    { text: 'Bektas Güvenlik', value: 1 },
                    { text: 'Sanat Güvenlik', value: 2 },
                ],
                cities: [
                    { text: 'İstanbul', value: 0 },
                    { text: 'İzmir', value: 1 },
                    { text: 'Ankara', value: 2 },
                    { text: 'Trabzon', value: 3 },
                    { text: 'Adana', value: 4 },
                    { text: 'Konya', value: 5 },
                    { text: 'Kayseri', value: 6 },
                    { text: 'Samsun', value: 7 },
                    { text: 'Sivas', value: 8 },
                ],
                districts: [
                    { text: 'Şişli', value: 0 },
                    { text: 'Ümraniye', value: 1 },
                    { text: 'Maltepe', value: 2 },
                    { text: 'Üsküdar', value: 3 },
                    { text: 'Kadıköy', value: 4 },
                    { text: 'Beşiktaş', value: 5 },
                    { text: 'Fatih', value: 6 },
                    { text: 'Beylikdüzü', value: 7 },
                    { text: 'Zeytinburnu', value: 8 },
                    { text: 'Turgutlu', value: 10 },
                    { text: 'Konak', value: 11 },
                    { text: 'Meram', value: 12 },
                    { text: 'Salihli', value: 3 },
                    { text: 'Alsancak', value: 4 },
                    { text: 'Karşıyaka', value: 5 },
                    { text: 'Göztepe', value: 6 },
                    { text: 'Suşehri', value: 7 },
                    { text: 'Merkez', value: 8 },
                ],
                jobs: [
                    { text: 'Güvenlik', value: 0 },
                    { text: 'Esnaf', value: 1 },
                    { text: 'Market', value: 2 },
                    { text: 'Mağaza', value: 3 },
                    { text: 'Büro', value: 4 },
                ],
                protocols: [
                    { text: 'Ademco Contact Id', value: 0 },
                    { text: 'SIA', value: 1 },
                    { text: '4x2', value: 2 },
                    { text: 'Prosec', value: 3 },
                ],
                devices: [
                    { text: 'Prosec', value: 0 },
                    { text: 'Crow', value: 1 },
                    { text: 'DSC', value: 2 },
                ],
                communicates: [
                    { text: 'GPRS', value: 0 },
                    { text: 'Tel Hattı', value: 1 },
                    { text: 'Ip Hattı', value: 2 },
                ],
                customerGroups: [
                    { text: 'A101', value: 0 },
                    { text: 'TCDD', value: 1 },
                    { text: 'X Bank', value: 2 },
                ],
                jsondata: [
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'Didem BEKTAŞ', idNo: '58878526485', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'}, 
                      {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'Didem BEKTAŞ', idNo: '58878526485', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'},
                    {name: 'MUSTAFA BEKTAŞ', idNo: '25181520284', address: 'Atakent Mahallesi Atakan Caddesi Öncü Sokak No 9', city: 'İSTANBUL', 
                     district: 'ÜMRANİYE', camera: 'Hayır', alarm: 'Evet', account: '1000-000', date: '05.10.2016'}, 
                ]
            
            }
        },
        components:{
            BreadCrumb, Modals, Multiselect
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
           
        }
    }
</script>

<style lang="css" scoped> 
    @import "./styles/report.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Reports/Safety.vue